import React from 'react';
import PropTypes from 'prop-types';
import AssistenteInlineIcon from '../Icons/AssistenteInlineIcon';

const apriPermalink = (permalink, codiceUfficio, area) => {
  window.open(`${window.config.urlAssistente}/permalink/contenuto?aliasArea=${area}&codiceUfficio=${codiceUfficio}&permalink=${permalink}`);
};

const AssistenteButton = ({ permalink,  codiceUfficio, area, inline, children }) => (
  inline
    ? (
      <span
        className="assistente--inline"
        onClick={() => apriPermalink(permalink, codiceUfficio, area)}
        role="presentation"
      >
        <AssistenteInlineIcon style={{
          width: '14px', height: '14px', float: 'left', marginTop: '2px',
        }}
        />
        {children}
      </span>
    )
    : (
      <span
        className="button--assistente"
        onClick={() => apriPermalink(permalink, codiceUfficio, area)}
        role="presentation"
      >
        <AssistenteInlineIcon onClick={() => apriPermalink(permalink, codiceUfficio, area)} />
      </span>
    )
);

AssistenteButton.propTypes = {
  permalink: PropTypes.string.isRequired,
  codiceUfficio: PropTypes.string.isRequired,
  area: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  children: PropTypes.node,
};

AssistenteButton.defaultProps = {
  children: undefined,
  inline: false,
};

export default AssistenteButton;
